import React from 'react';

const VARIANT_CLASS = {
  line: 'ads-tabs--line',
  pill: 'ads-tabs--pill',
};

export const AdsTab = ({
  children,
  active = false,
  onClick,
  icon: Icon,
  className = '',
  ...props
}) => (
  <button
    type="button"
    role="tab"
    aria-selected={active}
    className={['ads-tabs__tab', active ? 'is-active' : '', className].filter(Boolean).join(' ')}
    onClick={onClick}
    {...props}
  >
    {Icon ? <Icon size={16} strokeWidth={1.5} aria-hidden /> : null}
    {children}
  </button>
);

const AdsTabs = ({ children, variant = 'line', className = '', ...props }) => (
  <div
    className={['ads-tabs', VARIANT_CLASS[variant] || VARIANT_CLASS.line, className]
      .filter(Boolean)
      .join(' ')}
    role="tablist"
    {...props}
  >
    {children}
  </div>
);

export default AdsTabs;
